const deskTopTextStyles = require('./desktop/textStyles');
const mobileTextStyles = require('./mobile/textStyles');

module.exports = { deskTopTextStyles, mobileTextStyles };
